<div class="nearby-store-container">
  <div class="nearbyStore-mainStore-container">
    <div class="mainstore-image">
      <img [src]="storeList[0] | storeImage : attrCode.OUTLETIMG" alt="store image"
        onerror="this.src='assets/generalImage/broken_image.svg'" loading="lazy">
    </div>

    <div class="mainstore-detail">
      <h1 class="title">{{storeList[0].merchantDesc}}</h1>
      <h1 class="desc truncateText">{{ getStoreAttrDesc(storeList[0].storeCatgAttrs) }}</h1>

      <h1 class="nearby-desc" *ngIf="storeList.length > 1">{{ 'number.of.nearby.store' | translate: { count:
        storeList.length } }}</h1>
    </div>
  </div>

  <div class="nearbyStore-otherStore">
    <div *ngFor="let otherStore of storeList; last as isLast"
      [style.border-bottom]=" isLast ? 'none' : ' 0.5px solid var(--neutral-20)'">
      <div class="nearbyStore-otherStore-container"
        [ngClass]="{ 'disabled-store': otherStore.currentStatus !== storeStatusFlag.Open }"
        (click)="onNavigate(otherStore)">
        <h1 class="title">{{otherStore.locDesc}}</h1>

        <div class="nearbyStore-otherStore-detail">
          <div class="orderType" *ngIf="otherStore.currentOrderType ">
            <i class="{{otherStore.currentOrderType | orderTypeIcon}} item-order-type-icon"></i>
            <span>{{otherStore.currentOrderType}}</span>
          </div>

          <div class="distance" *ngIf="otherStore.distance">
            <i class="icon-shop-outlet"></i>
            <span>{{"label.distance" | translate: { distance: otherStore.distance | number : '.1-1' } }}</span>
          </div>

          <div class="rating" *ngIf="otherStore.ratingAverage && otherStore.ratingAverage !== 0">
            <i class="icon-rate-star"></i>
            <span>{{ otherStore.ratingAverage | number : '1.1' }}</span>
          </div>

          <div class="deliveryFee"
            *ngIf="otherStore.deliveryFee && otherStore.currentOrderType == orderTypeFlag.Delivery">
            {{ otherStore.deliveryFee | currency: currency.currCode : 'symbol-narrow'}}
          </div>
        </div>
      </div>

      <ng-template [ngIf]="otherStore.currentStatus !== storeStatusFlag.Open">
        <div class="nearbyStore-status">
          <i class="icon-calendar-time"></i>
          <ng-template [ngIf]="otherStore.currentStatus === storeStatusFlag.Closed && otherStore.currentOrderType != orderTypeFlag.DineIn
          && otherStore.storeOHSchedules && ((otherStore.storeOHSchedules?.delivery && otherStore.storeOHSchedules?.delivery?.length > 0)
          || (otherStore.storeOHSchedules?.pickup && otherStore.storeOHSchedules?.pickup?.length > 0))">
            <span> {{"pre.order.from" | translate}}</span>
            <span class="bold">{{otherStore.currentStatus | nextAvailableTime : otherStore}}</span>
          </ng-template>
          <span
            *ngIf="(otherStore.currentStatus === storeStatusFlag.Closed && otherStore.currentOrderType != orderTypeFlag.DineIn
          && ((otherStore.storeOHSchedules && (!otherStore.storeOHSchedules?.delivery || otherStore.storeOHSchedules?.delivery?.length == 0)
          && (!otherStore.storeOHSchedules?.pickup || otherStore.storeOHSchedules?.pickup?.length == 0)) || (!otherStore.storeOHSchedules)))
          || (otherStore.currentStatus === storeStatusFlag.Closed && otherStore.currentOrderType == orderTypeFlag.DineIn)">
            {{'store.closed' | translate}}</span>
          <span *ngIf="otherStore.currentStatus === storeStatusFlag.OutofCoverage">{{'label.status.out.of.coverage' |
            translate}}</span>
          <span *ngIf="otherStore.currentStatus === storeStatusFlag.TempClosed">{{'label.status.temporarily.closed' |
            translate}}</span>
        </div>
      </ng-template>
    </div>
  </div>
</div>
